export enum TransactionTypeEnum {
  Debit = 'debit',
  Credit = 'credit',
}
